<template>
  <el-container >
    <el-main>
      <el-row  justify="space-start" :gutter="20">
        <el-col :span="12">
          <el-card class="box-card">
            <h4 class="card-title">Add a new classroom</h4>
            <div class="card-content">
              <el-form :model="classroom" :rules="rules" ref="classroom" label-width="120px" class>
                <el-form-item label="Code" prop="code">
                  <el-input v-model="classroom.code"></el-input>  
                  <span class="text-muted">For OTP classrooms always use OTP at the start of the code</span>
                </el-form-item>
              
                <el-form-item label="Filter venues">
                  <venue-filter
                    :filter="venues"
                    v-model="classVenues"
                    v-on:update:classVenues="classVenues = $event"
                  ></venue-filter>
                </el-form-item>
                <el-form-item label="Venue">
                  <el-select
                    size="large"
                    class="form-group border-input"
                    placeholder="Select Venue"
                    v-model="classroom.venueId"
                    @change="setVenue"
                  >
                    <el-option
                      v-for="venue in classVenues"
                      class="select-danger"
                      :value="venue.id"
                      :label="venue.name"
                      :key="venue.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Tutor">
                  <el-select
                    size="large"
                    class="form-group border-input"
                    placeholder="Select Tutor"
                    v-model="classroom.tutorId"
                    @change="setTutor"
                  >
                    <el-option
                      v-for="tutor in tutors"
                      class="select-danger"
                      :value="tutor.id"
                      :label="tutor.firstname +' '+ tutor.lastname"
                      :key="tutor.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                  <el-form-item label="isOnline">
                  <el-checkbox v-model="classroom.isOnline"></el-checkbox>
                </el-form-item>
                <hr v-if="classroom.isOnline"/>
                <el-form-item v-if="classroom.isOnline" label="Meeting Url">
    <el-input v-model="classroom.meetingUrl"></el-input>
</el-form-item>
   <el-form-item v-if="classroom.isOnline" label="Meeting ID">
    <el-input v-model="classroom.meetingID"></el-input>
</el-form-item>
<el-form-item v-if="classroom.isOnline" label="Sessions">
    <el-date-picker
    value-format="yyyy-MM-dd"
      type="dates"
      @change="setStartDate"
      v-model="classroom.sessions"
      placeholder="Pick one or more dates">
    </el-date-picker>
</el-form-item>
<hr v-if="classroom.isOnline" />
                <el-form-item label="Start Date" prop="startDate">
                  <el-date-picker
                    v-model="classroom.startDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="Pick a day"
                    @change="setStartDate"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item label="Days">
                  <el-select
                    size="large"
                    class="form-group border-input"
                    placeholder="Select number of days"
                    v-model="classroom['length']"
                   
                  >
                    <el-option value="2" label="2"></el-option>
                    <el-option value="3" label="3"></el-option>
                     <el-option value="4" label="4 20 hr Online Class"></el-option>
                    <el-option value="5" label="5 OTP"></el-option>
                    <el-option value="6" label="6 30 hr Online Class"></el-option>
                  </el-select>
                  <small class="text-w">For OTP classes select 5, for 20hr Virtual select 4, for 30hr Virtual 6</small>
                </el-form-item>

                <el-form-item label="End Date" prop="endDate">
                  <el-date-picker
                   
                    v-model="classroom.endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="Select the end date"
                  ></el-date-picker>
                </el-form-item>
    <el-form-item label="Start Time">
                  <el-time-select
             
                    v-model="classroom.startTime"
                    :picker-options="{
    start: '01:00',
    step: '01:00',
    end: '24:00'
  }"
                    placeholder="Select Time"
                  ></el-time-select>
                </el-form-item>
                    <el-form-item label="End Time">
                  <el-time-select
             
                    v-model="classroom.endTime"
                    value-format="HH:mm"
                    format="HH:mm"
                    :picker-options="{
    start: '01:00',
    step: '01:00',
    end: '24:00'
  }"
                    placeholder="Select Time"
                  ></el-time-select>
                </el-form-item>
                <el-form-item label="Max Attendees">
                  <el-input v-model="classroom.maxAttendees"></el-input>
                </el-form-item>
 
                <el-form-item label="Enabled">
                  <el-switch v-model="classroom.isPublic" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="createClassroom('classroom')">Create</el-button>
                  <el-button @click="resetForm('classroom')">Reset</el-button>
                </el-form-item>

              </el-form>
            </div>
    
          </el-card>
        </el-col>
        <el-col :span="12" style="padding:100px;">
          <div class="alert alert-danger" style="border-radius:10px;"><strong style="color:#fff;">Important: </strong>Please note newly created classrooms will not show immediately on the website. Please allow 30 minutes for them to show on the location pages.</div>
        </el-col>
        
      </el-row>
    </el-main>
  </el-container>
</template>
<script>

import ClassroomFilter from "../UIComponents/ClassroomFilter.vue";
import VenueFilter from "../UIComponents/VenueFilter.vue";
import api from "./api";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";

const CREATE_CLASSROOM=gql`
  mutation createClassroom($classroom: [ClassRoom_insert_input!]!){
    insert_ClassRoom(objects:$classroom){
      returning{
        id

      }
      affected_rows
    }
  }
`;

export default {
  components: {
    ClassroomFilter,
    VenueFilter
  },
  data() {
    return {
    selectedDates:{},
      total: 0,
      countries: [],
      classrooms: [],
      classroomsCsv: [],
      newClassroom: {},
      csvArr: [],
      aggregate: {},
      total: 0,
      towns: 
        {
          EN: [],
          SS: [],
          WA: [],
          IE: [],
          ND: [],
          US: [],
          ES: []
        }
      ,
      classroom: {
        isPublic: "0",
        startDate:'',
        feedbackCount: "0",
        courseRatingPercentage: "0.0",
        venueRatingPercentage: "0.0",
        serviceRatingPercentage: "0.0",
        tutorRatingPercentage: "0.0",
        recommendedPercentage: "0.0",
        allRatingsPercentage: "0.0",
        historic: "0",
        invoiceSourceUrl: "",
        numberOfTens: "0",
        numAttendees: "0",
        invoiceAmount: "0",
        invoicePaid: "0",
        invoiceBonus: "0",
        additionalCost: "0",
        venueInvoicePaid: "0",
        maxAttendees: 20,
        sessions:[]
        
      },
     
      loadingClassrooms: false,
      selectedCountry: "",
      selectedVenue: {},
      selectedTutor: {},
      tutor: {},
      tutors: [],
      venues: [],
      classVenues: [],
      venue: {},
      loading: false,

      rules: {
        code: [
          { required: true, message: "Please add code", trigger: "blur" }
        ],
        endDate: [
          { required: true, message: 'Please pick an end date', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: 'Please pick a start date', trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    callIt(d){
    console.log(d)
    },
    setStartDate(d){
      console.log('date: ',d);
      if(Array.isArray(d)) {
        this.classroom.startDate=d[0]
        this.classroom.endDate=d[d.length-1]
      } else {
        this.classroom.startDate=d
      }
    },
    setSessions(d){
      //this.classroom.sessions=this.selectedDates.selectedDates.map((dates) => moment(dates.date).format('YYYY-MM-DD'))
      //console.log('sessions: ',d);
      this.classroom.startDate=this.classroom.sessions[0]
      this.classroom.endDate=this.classroom.sessions[this.classroom.sessions.length-1]
    },
    getVenues() {
      this.loadingVenues = true;

      this.$apollo
        .query({
          query: gql`
            {
              ClassRoomVenue(limit: 50) {
                id
                phone
                country
                line1
                line2
                town
                region
                postcode
                name
                website
                email
                contactName
                dateCreated
                dateUpdated
                lat
                long
                historic
              }
            }
          `,
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.classVenues = response.data.ClassRoomVenue;
          this.loadingVenues = false;
          //this.venueTotal = response.data.countUnlimited;
        });
    },

    setVenue(v) {
      this.selectedVenue = this.classVenues.find(x => x.id == v);
    },

    setEndDate(length) {
      this.classroom.endDate = moment(this.classroom.startDate).add(length-1, "days").format();
    },

    getCountries() {
      api.getCountries().then(response => {
        this.countries = response.data.data;
      });
    },

    getTownsByCountry(country) {
      if (country != 'All') {
        if (this.towns[country].length === 0) {
        this.$apollo
          .query({
            query: gql`
            {
              ClassRoomVenue(
                order_by: {town: asc},
                where: { country: {_eq: "${country}"} }
              ) {
                town
              }
            }`,
            error(error) {
              this.error = JSON.stringify(error);
            }
          })
          .then(response => {
            for (let venue of response.data.ClassRoomVenue) {
                this.towns[country].push(venue.town);
            }
            this.towns[country] = this.towns[country].filter(function(item, i, ar){ return ar.indexOf(item) === i; });
            this.filters[4].value = 'All'
            //return this.towns[country]
          });
        } else {
          this.filters[4].value = 'All'
          //return this.towns[country]
        }
      } else {
        //this.getVenues();
      }
    },

    

    getTutors() {
      this.loadingTutors = true;

      this.$apollo
        .query({
          query: gql`
            {
              Tutor(limit: 50, where: {isActive: {_eq: 1}}, order_by: {firstname: asc}) {
                id
                firstname
                lastname
                currency
                email
                rating
                isActive
                canLogin
                rating
                address {
                  id
                  line1
                  line2
                  country
                  town
                  phone
                }
              }
            }
          `,
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.tutors = response.data.Tutor;
          this.loadingTutors = false;
        });
    },

    setTutor(t) {
      this.selectedTutor = this.tutors.find(x => x.id == t);
    },

    createClassroom(formName) {
      this.classroom.dateCreated = moment().format()
      this.classroom.dateUpdated = moment().format()
      const classroom = this.classroom && this.classroom
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('classroom: ',classroom)
          
          this.$apollo.mutate({
            mutation:CREATE_CLASSROOM,
            variables:{
              classroom:classroom
            }
          }).then(result => {
            this.$notify({
              title: "Success",
              message: "Classroom Created",
              type: "success"
            });
            this.$router.push({path:'/classroom/list/'})
          }).catch(error => {
            this.$notify({
              title: "Error",
              message: error.message,
              type: "error"
            });
          });
          
      } else {
          this.$notify({
            title: "Error Creating Classroom",
            message: "Please check you have filled in the required fields",
            duration: 0,
            type: "error"
          });
          return false;
        }
      });
    },

    async getTutorVenue(row, expanded) {
      //don't bother if closing the row or we already got the data
      if (expanded.length && !row.venue) {
        this.loading = true;
        //only call getTutor if classroom as a tutor-id else resolve to 'No Tutor Assigned'
        const getTutor = row.tutor.id
          ? api.getTutor(row.tutor.id)
          : new Promise((resolve, reject) =>
              resolve({ data: { data: "No Tutor Assigned" } })
            );
        const getVenue = api.getVenue(row.meta["venue-id"]);
        const getAttendees = api.getOrdersByClassroomId(row.id);
        // Call both functions with promise.all
        await Promise.all([getTutor, getVenue, getAttendees]).then(response => {
          row.meta.tutor = response[0].data.data;
          row.meta.venue = response[1].data.data;
          row.meta.attendees = response[2].data;
          this.loading = false;
        });
      }
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    
  },
  mounted() {
    this.getTutors();
    this.getVenues();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Classrooms/Create.vue